import { render, staticRenderFns } from "./banks-form.vue?vue&type=template&id=7d0f35a6&"
import script from "./banks-form.vue?vue&type=script&lang=js&"
export * from "./banks-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports